import mimetics from "mimetics";
import { ZendeskAPI } from "react-zendesk";

import { config } from "_config";
import { history } from "./history";

export function handleResponse(response, options = {}) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401 || (!options?.allowForbidden && response.status === 403)) {
        ZendeskAPI(function () {
          ZendeskAPI("webWidget", "hide");
        });

        localStorage.removeItem("trademark-membership-user");
        localStorage.removeItem("userInfo");
        history.push(config.publicUrl + "/login");
      }

      const errorData = (data && data.message) || response.statusText;
      let errorMessage = errorData;

      if (errorData === "Too Many Requests" && response?.url?.includes("/create-delayed-upsale")) {
        errorMessage = "Daily limit reached, you can only purchase 3 services per day. Please try again tomorrow.";
      }

      const error = new Error(errorMessage);
      error.isResponse = true;

      return Promise.reject(error);
    } else {
      const data = text && JSON.parse(text);

      return data;
    }
  });
}

export function handleResponseLogin(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const errorMessage = (data && data.message) || response.statusText;
      const error = new Error(errorMessage);
      error.isResponse = true;

      return Promise.reject(error);
    } else {
      const data = text && JSON.parse(text);

      return data;
    }
  });
}

// export function saveFile(response) {
//   if (!response.ok) {
//     return Promise.reject("An error occurred while downloading the file");
//   }

//   const name = response.headers.get("content-disposition").split("filename=")[1].split(";")[0].replace(/"/g, "");

//   response.blob().then((blob) => {
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;

//     link.setAttribute("download", name);
//     document.body.appendChild(link);
//     link.click();
//     link.parentNode.removeChild(link);
//   });

//   return true;
// }

export function saveFile(response, filename, useNameFromHeader, checkMime) {
  // eslint-disable-next-line no-useless-escape
  const name = response.headers.get("content-disposition").split("filename=")[1].split(";")[0].replace(/\"/g, "");

  response
    .arrayBuffer()
    .then((buffer) => {
      let fileInfo = {};
      try {
        fileInfo = mimetics(buffer);
      } catch (error) {
        console.error("Something went wrong with file recognizing\n", error);
      }

      const blob = new Blob([buffer]);
      return { blob, fileInfo };
    })
    .then(({ blob, fileInfo }) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      let resultName = "";

      link.href = url;

      if (useNameFromHeader && name) {
        resultName = name;
      } else {
        resultName = filename;
      }

      if (checkMime && fileInfo?.ext) {
        if (resultName?.split(".")?.slice(-1)[0] !== fileInfo?.ext) {
          resultName += `.${fileInfo?.ext}`;
        }
      }

      link.setAttribute("download", resultName);

      // if (useNameFromHeader) {
      //   if (fileInfo?.ext && name?.split(".")?.slice(-1)[0] !== fileInfo?.ext) {
      //     link.setAttribute("download", name + "." + fileInfo?.ext || filename + "." + fileInfo?.ext);
      //   } else {
      //     link.setAttribute("download", useNameFromHeader ? name || filename : filename);
      //   }
      // } else if (fileInfo?.ext && filename?.split(".")?.slice(-1)[0] !== fileInfo?.ext) {
      //   link.setAttribute("download", filename + "." + fileInfo?.ext);
      // } else {
      //   link.setAttribute("download", useNameFromHeader ? name || filename : filename);
      // }

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });

  return true;
}
